module.exports = __webpack_public_path__ + "static/media/Docker.1380befa.svg";